export default __webpack_public_path__ + "media/components/InstructionButton/images/rule3-ef39644c122e8616200d62561a2992c0.png";